// extracted by mini-css-extract-plugin
module.exports = {"questions":"Questions_questions__A_J3w","question_modal":"Questions_question_modal__O5dQF","rules_modal":"Questions_rules_modal__pbhMf"};